/**
 * Category helpers for Ashluxe search suggestions / result relevance.
 * Search always stays on /search — no collection redirects.
 */
(function (global) {
  const CATEGORIES = [
    {
      label: 'T-Shirts',
      aliases: ['t-shirt', 't-shirts', 'tshirt', 'tshirts', 'tee', 'tees'],
      stems: ['t-shirt', 'tshirt', 'tee']
    },
    {
      label: 'Shirts',
      aliases: ['shirt', 'shirts'],
      stems: ['shirt']
    },
    {
      label: 'Pants',
      aliases: ['pant', 'pants', 'trouser', 'trousers', 'jean', 'jeans', 'denim'],
      stems: ['pant', 'trouser', 'jean', 'denim']
    },
    {
      label: 'Shorts',
      aliases: ['short', 'shorts'],
      stems: ['shorts']
    },
    {
      label: 'Bikinis',
      aliases: ['bikini', 'bikinis', 'swimwear', 'swimsuit', 'swimsuits'],
      stems: ['bikini', 'swimwear', 'swimsuit']
    },
    {
      label: 'Hoodies',
      aliases: ['hoodie', 'hoodies', 'sweatshirt', 'sweatshirts', 'pullover', 'pullovers'],
      stems: ['hoodie', 'sweatshirt', 'pullover']
    },
    {
      label: 'Jackets',
      aliases: ['jacket', 'jackets', 'coat', 'coats', 'blazer', 'blazers', 'varsity', 'bomber', 'bombers'],
      stems: ['jacket', 'coat', 'blazer', 'varsity', 'bomber']
    },
    {
      label: 'Jerseys',
      aliases: ['jersey', 'jerseys'],
      stems: ['jersey']
    },
    {
      label: 'Dresses',
      aliases: ['dress', 'dresses'],
      stems: ['dress']
    },
    {
      label: 'Skirts',
      aliases: ['skirt', 'skirts'],
      stems: ['skirt']
    },
    {
      label: 'Bags',
      aliases: ['bag', 'bags', 'tote', 'totes'],
      stems: ['bag', 'tote']
    },
    {
      label: 'Caps',
      aliases: ['cap', 'caps', 'hat', 'hats', 'headwear', 'headwears'],
      stems: ['cap', 'hat', 'headwear']
    },
    {
      label: 'Vests',
      aliases: ['vest', 'vests'],
      stems: ['vest']
    }
  ];

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_/]+/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function wordForms(value) {
    const w = normalize(value);
    if (!w) return [];
    const forms = new Set([w]);
    if (w.endsWith('ies') && w.length > 4) forms.add(w.slice(0, -3) + 'y');
    if (w.endsWith('ses') || w.endsWith('xes') || w.endsWith('zes')) forms.add(w.slice(0, -2));
    if (w.endsWith('s') && !w.endsWith('ss') && w.length > 3) forms.add(w.slice(0, -1));
    if (!w.endsWith('s')) forms.add(w + 's');
    return Array.from(forms);
  }

  function matchCategory(query) {
    const q = normalize(query);
    if (!q) return null;

    const queryForms = wordForms(q);
    let best = null;
    let bestAliasLength = -1;

    CATEGORIES.forEach((category) => {
      category.aliases.forEach((alias) => {
        const aliasForms = wordForms(alias);
        const matched = queryForms.some((form) => aliasForms.includes(form));
        if (matched && alias.length > bestAliasLength) {
          best = category;
          bestAliasLength = alias.length;
        }
      });
    });

    return best;
  }

  function productMatchesCategory(product, category) {
    if (!category) return true;

    const type = normalize(product.product_type || product.type || '');
    const title = normalize(product.title || '');
    const stems = category.stems || [];

    if (stems.some((stem) => {
      const s = normalize(stem);
      return type === s || type === `${s}s`;
    })) {
      return true;
    }

    if (stems.some((stem) => {
      const s = normalize(stem);
      if (s.length < 4 || !title.includes(s)) return false;
      if (s === 'shirt' && (title.includes('t-shirt') || title.includes('tshirt'))) return false;
      return true;
    })) {
      return true;
    }

    return false;
  }

  function filterProductsByCategory(products, query) {
    const category = matchCategory(query);
    if (!category) return products;
    return products.filter((product) => productMatchesCategory(product, category));
  }

  global.AshSearchCategories = {
    list: CATEGORIES,
    normalize,
    wordForms,
    matchCategory,
    productMatchesCategory,
    filterProductsByCategory
  };
})(typeof window !== 'undefined' ? window : globalThis);
